import React from 'react';
import { Globe2, Mail, Phone, Calendar } from 'lucide-react';
import { BookingDetails, BookingActions } from './BookingDetails';

const BADGE = { paid: 'bg-teal-100 text-teal-800', pending: 'bg-amber-100 text-amber-800', awaiting_transfer: 'bg-sky-100 text-sky-800', cancelled: 'bg-slate-100 text-slate-500' };
const STATUS = { pending: 'Not paid', awaiting_transfer: 'Awaiting bank transfer', cancelled: 'Cancelled' };

export const BookingsPanel = ({ bookings, fmt, reload }) => (
  <div data-testid="bookings-panel" className="bg-white rounded-2xl border border-teal-50 overflow-hidden">
    {bookings.length === 0 ? <p className="text-slate-500 p-8 text-center">No online bookings yet.</p> : bookings.map((b) => (
      <div key={b.id} data-testid={`booking-row-${b.id}`} className="p-5 border-b border-teal-50 last:border-0">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2 font-semibold text-teal-900"><Globe2 size={16} className="text-teal-600" /> {b.name} <span className="font-normal text-slate-500">· {b.country}</span></div>
          <div className="flex items-center gap-3">
            <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${BADGE[b.status] || 'bg-slate-100 text-slate-600'}`}>{b.status === 'paid' ? `Paid ${b.currency === 'INR' ? '\u20b9' : 'USD '}${(b.amount / 100).toLocaleString('en-IN')}` : STATUS[b.status] || 'Not paid'}</span>
            <span className="flex items-center gap-1 text-xs text-slate-400"><Calendar size={13} /> {fmt(b.paid_at || b.created_at)}</span>
          </div>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-1 mt-2 text-sm text-slate-600">
          {b.slot_date && <span data-testid={`booking-slot-${b.id}`} className="font-semibold text-teal-800">{new Date(`${b.slot_date}T${b.slot_time}:00+05:30`).toLocaleString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' })} IST</span>}
          <span className="flex items-center gap-1"><Phone size={13} className="text-teal-600" /> {b.whatsapp}</span>
          <span className="flex items-center gap-1"><Mail size={13} className="text-teal-600" /> {b.email}</span>
          {b.payment_id && <span className="text-xs text-slate-400">Payment {b.payment_id}</span>}
        </div>
        {b.concern && <p className="text-sm text-slate-600 mt-2 bg-teal-50/50 rounded-lg p-3">{b.concern}</p>}
        <BookingDetails b={b} />
        <BookingActions b={b} reload={reload} />
      </div>
    ))}
  </div>
);
